import { render } from "./SemesterList.vue?vue&type=template&id=a8db7fe8"
import script from "./SemesterList.vue?vue&type=script&lang=js"
export * from "./SemesterList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__